<template lang="pug">
.mainbody
    main.mainbox.bg-white
        slot

    .fixed.bottom-3.right-3.z-10
        Color
</template>
<script setup lang="ts">
defineProps<{
  title?: string;
  navbar?: boolean;
}>();

const fullpage = ref<HTMLElement | null>(null);
const fullpage2 = ref<HTMLElement | null>(null);

onMounted(() => {
  if (fullpage && fullpage.value) {
    const rect = computed(() => fullpage.value?.getBoundingClientRect().top);
    fullpage.value!.style.height = `calc(100vh - ${rect.value}px)`;
  }
  if (fullpage2 && fullpage2.value) {
    const rect2 = computed(() => fullpage2.value?.getBoundingClientRect().top);
    fullpage2.value!.style.height = `calc(100vh - ${rect2.value}px)`;
  }
});
</script>
